import { render, staticRenderFns } from "./BusinessNameDataUpdateTaskQueueLevel2.vue?vue&type=template&id=7b61962c&scoped=true&"
import script from "./BusinessNameDataUpdateTaskQueueLevel2.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateTaskQueueLevel2.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateTaskQueueLevel2.vue?vue&type=style&index=0&id=7b61962c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b61962c",
  null
  
)

export default component.exports